// Common
import React from 'react';

// Moment
import moment from 'moment';
import 'moment/locale/ru';

// Data
import data from './data/data';
import data_archive from './data/data_archive';
import output from './data/output';
import ThreeDatePicker from './three_calendar';

// Locale
// import locale from '../data/locale'
import locale from 'antd/lib/date-picker/locale/ru_RU';

// Output day
import OutputDay from './output_day';

// Ant
import { 
    Icon,
    Table,
    Typography,
    Select,
    Button,
    Input,
    DatePicker,
    Row, 
    Drawer,
    Col
} from 'antd';

const { Text } = Typography;
const { Option } = Select;
// const confirm = Modal.confirm;
const Search = Input.Search;
const InputGroup = Input.Group;
// const { RangePicker } = DatePicker;


moment.locale('ru');

class Pick_New_Order extends React.Component{

    constructor(props) {
        super(props);
        this.state = {
            visible_output_day: false,
            filtered_info: {
                type: ['archive'],
                date_create: [0, 99999999999999]
            },
            search_text: '',
            sorted_info: null,  
            output: [],
            selectedRowKeys: [],
            active: [],
            archive: [],
            types: {
                current: 'active'
            },
            data: {
                select: [],
                order_select: [],
                data_select: []
            },
            pagination: {
                pages: 3
            },
            event: null
        }
    }

    componentDidMount() {

        // Даты
        this.setState((state, props) => ({
            active: data,
            archive: data_archive,
            data: {
                ...state.data,
                select: data
            },
            output: output
        }))

    }

    componentDidUpdate(prevProps, prevState){

        

    }

    // Событие в range picker
    change_range_picker = (dates, dateString) => {
        // console.log(dates, dateString);
    }

    // Неактивные даты
    disabled_date(current) {
        return current && current.unix() < moment().unix() - 43200;
    }

    // Работа с таблицей
    change_events_table = (pagination, filters, sorter) => {
        
    };

    // Вывод таблицы
    render_auto_order_table(){

        const { selectedRowKeys } = this.state;
        let { filtered_info } = this.state;
        // let { sorted_info, filtered_info } = this.state;
        filtered_info = filtered_info || {};
        // sorted_info = sorted_info || {};

        const rowSelection = {
            selectedRowKeys,
            onChange: (selectedRowKeys, selectedRows) => {
                this.setState((state, props) => ({
                    selectedRowKeys,
                    data: {
                        ...state.data,
                        data_select: selectedRows
                    }
                }))
            }
        };
        
        const { pages } = this.state.pagination;
        const data = this.state.data.select;


        let columns = [
            {
                title: 'Номер заказа',
                dataIndex: 'order',
                key: 'order',
                render: order => (
                    <span>
                        <span className="item__order-number">{order.number}</span>
                        <Text type="secondary">Создан: {moment(parseInt(order.date_create)).format('DD.MM.YYYY')}</Text>
                    </span>
                ),
                filteredValue: filtered_info.date_create || null,
                onFilter: (value, record) => {
                    return filtered_info.date_create[0] <= record.order.date_create && filtered_info.date_create[1] >= record.order.date_create
                },
                sorter: (a, b) => { return a.order.number.localeCompare(b.order.number)}
            },{
                title: 'Вид',
                dataIndex: 'view',
                key: 'view',
                render: view => (
                    <span>{view}</span>
                ),
                sorter: (a, b) => { return a.view.localeCompare(b.view)}
            },{
                title: 'Статус',
                dataIndex: 'state',
                key: 'state',
                render: state => (
                    <span className="item__state">
                        <span style={{ color: (state.type === 'tobook' && '#9b9b9b') || (state.type === 'ready' && '#97dc76') }}>&bull;</span> {state.type === 'tobook' && <span>Бронь</span>}{state.type === 'ready' && <span>Готов к вып.</span>}{state.type === 'success' && <span>Выполнен</span>}
                        <br/>
                        {state.accepted && <Text style={{ fontWeight: 500 }}>Принят</Text>}
                        {state.accepted === false && <Text type="secondary">Не принят</Text>}
                        {state.check === false && <Text type="secondary">Не требует пр.</Text>}
                    </span>
                ),
                filteredValue: filtered_info.state || null,
                onFilter: (value, record) => {
                    return record.state.type.includes(value)
                },
                sorter: (a, b) => { return a.state.type.localeCompare(b.state.type)}
            },{
                title: 'Пасс.',
                dataIndex: 'passengers',
                key: 'passengers',
                render: passengers => (
                    <span>{(passengers && passengers) || '—'}</span>
                ),
                sorter: (a, b) => { return a.passengers.localeCompare(b.passengers)}
            },{
                title: 'Дата подачи',
                dataIndex: 'date_of_application',
                key: 'date_of_application',
                render: date_of_application => (
                    <span className="item__date_of_application">
                        {moment(parseInt(date_of_application)).format('DD.MM.YYYY HH:mm')} <br/>
                        <Text type="secondary">{moment(parseInt(date_of_application)).fromNow()}</Text>
                    </span>
                ),
                sorter: (a, b) => { return a.date_of_application.localeCompare(b.date_of_application)}
            },{
                title: 'Место подачи',
                dataIndex: 'place_of_supply',
                key: 'place_of_supply',
                render: place_of_supply => (
                    <span>
                        <span className="item__street">{place_of_supply.street}</span>
                        <Text type="secondary">{place_of_supply.city}</Text>
                    </span>
                ),
                sorter: (a, b) => { return a.place_of_supply.city.localeCompare(b.place_of_supply.city) || a.place_of_supply.street.localeCompare(b.place_of_supply.street)}
            }
        ];

        return (
            <div className="auto-order__table">
                <Table
                    dataSource={data}
                    pagination={{
                        pageSize: pages
                    }}
                    rowSelection={rowSelection}
                    rowKey="key"
                    columns={columns}
                    onChange={this.change_events_table}>
                </Table>
            </div>
        )
    }

    // Выбор кол-во отображаемыъ элементов в таблице
    change_auto_order_size = e => {
        this.setState((state, props) => ({
            pagination: {
                pages: e
            }
        }));
    }

    // Вывод кол-во отображаемых строк
    render_auto_order_pages(){
        return (
            <div className="auto-order__pages">
                <span className="auto-order__pages-title">Показать на странице</span>
                <Select defaultValue={this.state.pagination.pages} style={{ width: 80 }} onChange={this.change_auto_order_size}>
                    <Option value="3">3</Option>
                    <Option value="5">5</Option>
                    <Option value="10">10</Option>
                </Select>
            </div>
        )
    }

    // Поиск по номеру заказа
    handle_search_auto_order_change = e => {
        const { value } = e.target;
        this.setState((state, props) => ({
            search_text: value
        }))
    }

    // Поиск по номеру заказа
    handle_search_auto_order_search = e => {

        let types_current = this.state.types.current,
            data = this.state[types_current],
            searchText = this.state.search_text,
            reg = new RegExp(searchText, 'gi');

        this.setState((state, props) => ({
            filtered_search: !!searchText,
            data: {
                ...state.data,
                select: data.map((record) => {
                    const match = record.order.number.match(reg);
                    if (!match) {
                        return null;
                    }
                    return {
                        ...record,
                        name: (
                            <span>
                            {record.order.number.split(reg).map((text, i) => (
                                i > 0 ? [<span>{match[0]}</span>, text] : text
                            ))}
                            </span>
                        ),
                    };
                }).filter(record => !!record),
            }
        }));

    }

    // Действия с выбранными данными из таблицы
    handle_data_event = e => {
        this.setState((state, props) => ({
            event: e
        }))
    }

    // Выбор типа
    change_type_data = (e) => {
        this.setState((state, props) => ({
            types: {
                current: e.target.value
            },
            data: {
                ...state.data,
                select: this.state[e.target.value]
            }
        }));
    }

    // Выбор статуса
    handle_filter_state = (e) => {
        this.setState((state, props) => ({
            filtered_info: {
                ...state.filtered_info,
                state: (e && [e]) || null
            }
        }))
    }

    // Выбор диапазона дат от
    change_filter_from_date = (date, dateString) => {
        this.setState((state, props) => ({
            filtered_info: {
                ...state.filtered_info,
                date_create: [(date && parseInt(date.format('x'))) || 0, this.state.filtered_info.date_create[1]]
            }
        }))
    }

    // Выбор диапазона дат до
    change_filter_to_date = (date, dateString) => {
        this.setState((state, props) => ({
            filtered_info: {
                ...state.filtered_info,
                date_create: [this.state.filtered_info.date_create[0], (date && parseInt(date.format('x'))) || 99999999999999]
            }
        }))
    }

    // Показать не рабочие дни
    show_drawer_output_day = () => {
        this.setState((state, props) => ({
            visible_output_day: true
        }))
    }

    // Спрятать не рабочие дни
    hide_drawer_output_day = () => {
        this.setState((state, props) => ({
            visible_output_day: false
        }))
    }

    // Сбросить выбранные ТС
    reset_excluded_ts_select = () => {
        this.setState((state, props) => ({
            selectedRowKeys: [],
            data: {
                ...state.data,
                data_select: []
            }
        }));
    }

    render(){

        const { output, filtered_info } = this.state;

        let excluded = this.state.data.data_select,
            excluded_ts_select = 'excluded-ts__select';

            if(excluded && excluded.length){
                excluded_ts_select = 'excluded-ts__select active';
            }

        return (
            <div className="auto-order__wrap">
                <Drawer
                    title={<div><h2>Отметить нерабочие дни</h2>Александровский Александр Александрович</div>}
                    width={896}
                    placement={'left'}
                    closable={false}
                    onClose={this.hide_drawer_output_day}
                    visible={this.state.visible_output_day}
                    className="auto-order"
                >
                    <Button className="exclude_ts__hide" onClick={this.hide_drawer_output_day} type="primary" shape="circle" icon="close" size={'small'} />
                    <OutputDay orders={this.state.data.select} />
                </Drawer>
                <ThreeDatePicker output={output} orders={this.state.data.select} date_range={filtered_info.date_create} />
                <Row style={{ width: 500, marginBottom: 32 }} gutter={16}>
                    <Col span={14}>
                        <InputGroup compact style={{ width: '100%' }}>
                            <DatePicker 
                                onChange={this.change_filter_from_date} 
                                style={{ width: '50%' }} 
                                placeholder="от"
                                format={'DD.MM.YYYY'}
                                locale={locale}
                            />
                            <DatePicker 
                                onChange={this.change_filter_to_date} 
                                style={{ width: '50%' }} 
                                placeholder="до"
                                format={'DD.MM.YYYY'}
                                locale={locale}
                            />
                        </InputGroup>
                    </Col>
                    <Col span={10}>
                        <Search
                            style={{ width: '100%', float: 'right' }}
                            placeholder="Поиск по заказам"
                            onChange={this.handle_search_auto_order_change}
                            onSearch={this.handle_search_auto_order_search}
                        />
                    </Col>
                </Row>
                <div className="auto-order__content">
                    {this.render_auto_order_table()}
                    {this.render_auto_order_pages()}
                </div>
                <div className="auto-order__footer">
                    <div className="auto-order__footer-left">
                        <div className={excluded_ts_select}>
                            <div className="excluded-ts__select-count">
                                {excluded && excluded.length > 0 && (<Icon type="info" />)} Выбрано заказов: {excluded && excluded.length}
                            </div>
                            {excluded && excluded.length > 0 && <Button onClick={this.reset_excluded_ts_select} className="excluded-ts__reset" type="link">Сбросить</Button>}
                        </div>
                    </div>
                    <div className="auto-order__footer-right">
                        <Button style={{ width: 176, marginRight: 16 }} onClick={this.props.hide_drawer_pick_new_order} ghost type="primary">Отмена</Button>
                        <Button disabled={!excluded.length} type="primary">Назначить на заказы</Button>
                    </div>
                </div>
            </div>
        )
    }
}

export default Pick_New_Order;
